import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Markdown from '../../Shared/Markdown/Markdown';
import { FeatureCardStyles } from './FeatureCard.styled';
import StArrowRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/st-arrow-right.svg';
import { formatHttpsUrl, auditMarkdownLinks } from '@utils/utils';
import LinkWrapper from '../../LinkWrapper/LinkWrapper';

const FeatureCard = ({ card, cardFeatureId, imagePlacement }) => {
  const getSectionHeader = (url, txt) => {
    return url && txt ? (
      <LinkWrapper url={url} className={card.gtm?.header}>
        <h3>{txt}</h3>
      </LinkWrapper>
    ) : (
      ''
    );
  };

  const getSectionLink = (url, txt) => {
    return url && txt ? (
      <LinkWrapper url={url} className={card.gtm?.text}>
        <h5>{txt}</h5>
        <span className="link-arrow">
          <StArrowRightSvg />
        </span>
      </LinkWrapper>
    ) : (
      ''
    );
  };

  useEffect(() => {
    auditMarkdownLinks('card-desc');
  }, []);

  return (
    <FeatureCardStyles imagePlacement={imagePlacement}>
      <section className="card-grid" id={'card-anchor-' + cardFeatureId}>
        <div className="card-grid-picture">
          {getSectionHeader(card.sectionLink, card.sectionHeader)}
          <LinkWrapper url={card.sectionLink} className={card.gtm?.image}>
            <div className="feature-image-wrapper">
              <Image
                src={formatHttpsUrl(
                  `${card.featuredImage?.file?.url}?w=506&fm=webp`
                )}
                alt={card.featuredImage?.description}
                width={506}
                height={506}
              />
            </div>
          </LinkWrapper>
        </div>
        <div className="card-grid-detail">
          {getSectionHeader(card.sectionLink, card.sectionHeader)}
          <div className="card-desc">
            <Markdown markdown={card.sectionContent} />
          </div>
          <div className="card-link">
            {getSectionLink(card.sectionLink, card.sectionLinkText)}
          </div>
        </div>
      </section>
    </FeatureCardStyles>
  );
};

export default FeatureCard;

FeatureCard.propTypes = {
  card: PropTypes.object,
  cardFeatureId: PropTypes.number,
  imagePlacement: PropTypes.string,
};
